<template>
  <div @wheel="handleWheel" id="app" :class="{ 'dark-mode': isDarkMode }">
    <Header @toTop="GoTop" @toBottom="GoBottom"></Header>
    <div id="contentApp">
      <router-view />
    </div>
    <Footer></Footer>
    <GoTop></GoTop>
    <Agentation v-if="isDev" />
  </div>
</template>

<script>
import {
  mapState
} from "vuex"

// 只在开发环境中导入Agentation
let Agentation = null
if (process.env.NODE_ENV === 'development') {
  const agentationModule = require('agentation-vue2')
  Agentation = agentationModule.Agentation
  require('agentation-vue2/dist/agentation-vue2.css')
}

export default {
  name: 'App',
  components: {
    Agentation
  },
  data() {
    return {
      isDev: process.env.NODE_ENV === 'development'
    }
  },
  mounted() {
    const value = sessionStorage.getItem("scrollType")
    this.$store.commit('setScrollType', value);
    // 初始化主题
    if (this.isDarkMode) {
      document.documentElement.classList.add('dark-mode');
    }
  },
  destroyed() {
    sessionStorage.setItem('scrollType', this.scrollType)
  },
  computed: {
    ...mapState(['scrollType', 'isDarkMode']),
  },
  watch: {
    isDarkMode(newValue) {
      if (newValue) {
        document.documentElement.classList.add('dark-mode');
      } else {
        document.documentElement.classList.remove('dark-mode');
      }
    }
  },
  methods: {
    GoTop() {
      // 直接滚动到顶部，不使用递归动画，避免锁定滚动条
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    GoBottom() {
      const scrollHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const scrollBottom = scrollHeight - windowHeight;

      const scrollStep = 100; // 每次滚动的距离
      let scrollPosition = window.pageYOffset;

      function smoothScroll() {
        if (scrollPosition < scrollBottom) {
          window.scrollTo(0, scrollPosition);
          scrollPosition += scrollStep;
          if (scrollPosition > scrollBottom) {
            scrollPosition = scrollBottom;
          }
          window.requestAnimationFrame(smoothScroll);
        } else if (scrollPosition >= scrollBottom) {
          window.scrollTo(0, scrollHeight); // 滚动到页面的真正底部
          // 滚动到底部后执行的操作
          // 在这里添加你需要执行的代码
        }
      }

      smoothScroll();
    },
    handleWheel(event) {
      if (event) {
        this.$store.commit('setScrollType', event.deltaY);
      }
    },
  }
}
</script>

<style>
/* 全局CSS变量 - 浅色模式 */
:root {
  /* 主题颜色 */
  --primary-color: #10ccd2;
  --primary-hover: #0dc5cc;
  --secondary-color: #f0f9ff;
  
  /* 背景颜色 */
  --bg-primary: #ffffff;
  --bg-secondary: #f8f9fa;
  --bg-tertiary: #f0f0f0;
  
  /* 文本颜色 */
  --text-primary: #333333;
  --text-secondary: #6c757d;
  --text-tertiary: #adb5bd;
  
  /* 边框颜色 */
  --border-color: #e9ecef;
  --border-light: #f0f0f0;
  
  /* 阴影 */
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.1);
  
  /* 过渡动画 */
  --transition: all 0.3s ease;
}

/* 深色模式 */
.dark-mode {
  /* 主题颜色 */
  --primary-color: #38bdf8;
  --primary-hover: #22d3ee;
  --secondary-color: #1e293b;
  
  /* 背景颜色 */
  --bg-primary: #0f172a;
  --bg-secondary: #1e293b;
  --bg-tertiary: #334155;
  
  /* 文本颜色 */
  --text-primary: #f8fafc;
  --text-secondary: #cbd5e1;
  --text-tertiary: #94a3b8;
  
  /* 边框颜色 */
  --border-color: #334155;
  --border-light: #475569;
  
  /* 阴影 */
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.3);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.4);
  --shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.5);
}

html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: var(--transition);
}

body{
  overflow-x: hidden;
}

#app {
  background-color: var(--bg-primary);
  color: var(--text-primary);
  transition: var(--transition);
}

#contentApp {
  min-height: calc(100% - 300px);
  /* 这里的 [footer-height] 指 footer 的高度，例如 '100px' */
  box-sizing: border-box;
  background-color: var(--bg-primary);
  transition: var(--transition);
}

@media screen and (max-width: 997px) {
  #contentApp {
  /* min-height: calc(100% - 300px); */
  /* 这里的 [footer-height] 指 footer 的高度，例如 '100px' */
  box-sizing: border-box;
}
}
</style>



// WEBPACK FOOTER //
// src/App.vue